import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { FuseDirectivesModule } from '../../standalone-packages/ecap3/template-atlas';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { SharedDirectiveModule } from '../../directives/shared-directive.module';
import { TranslatePipe } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeleteModalComponent } from '../delete-modal/delete-modal.component';

@Component({
    selector: 'service-reject-modal',
    templateUrl: './service-reject-modal.component.html',
    standalone: false
})
export class ServiceRejectModalComponent implements OnInit, OnDestroy {
    HeaderText = 'DeleteModal.header_text';
    BodyText = '';
    ButtonNoText = 'CANCEL';
    ButtonRejectText = 'REJECT'
    ButtonRejectWithMail = 'REJECT_WITH_MAIL';
    private destroy$: Subject<boolean> = new Subject<boolean>();




    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        public dialogRef: MatDialogRef<DeleteModalComponent>
    ) {}

    ngOnInit(): void {
        this.modalDataInit();
        this.keydownListener();
    }

    modalDataInit() {
        this.HeaderText = this.data.HeaderText ? this.data.HeaderText : this.HeaderText;
        this.BodyText = this.data.BodyText ? this.data.BodyText : this.BodyText;
        this.ButtonNoText = this.data.ButtonNoText == null ? null : this.data.ButtonNoText ? this.data.ButtonNoText : this.ButtonNoText;
        this.ButtonRejectWithMail = this.data.ButtonRejectWithMail == null ? null : this.data.ButtonRejectWithMail ? this.data.ButtonRejectWithMail : this.ButtonRejectWithMail;
        this.ButtonRejectText = this.data.ButtonRejectText == null ? null : this.data.ButtonRejectText ? this.data.ButtonRejectText : this.ButtonRejectText;
    }

    keydownListener() {
        this.dialogRef
            .keydownEvents()
            .pipe(takeUntil(this.destroy$))
            .subscribe(event => {
                if (event.key == 'Enter') {
                    this.submitForm(false);
                }
            });
    }

    submitForm(isServiceRejectOnMail: boolean) {
        const serviceRejectInfo = {
            isServiceReject: true,
            isServiceRejectOnMail: isServiceRejectOnMail
        }
        this.dialogRef.close(serviceRejectInfo);
    }

    cancel() {
        this.dialogRef.close(false);
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
